import type { RatingT } from '@mentimeter/question-modules-types';
import type {
  InteractiveContentChoice,
  RatingResult,
  RatingAverage,
  RatingResponse,
} from '@core-api/presentation/types/response';

const averageToPoint = (
  score: [number | null, number | null],
): RatingAverage | null => {
  if (score[0] === null || score[1] === null) {
    return null;
  }
  return { x: score[0], y: score[1] };
};

const voteToPoint = (
  vote: [number, number] | [] | undefined,
): RatingResponse =>
  Array.isArray(vote) && vote.length === 2
    ? { x: vote[0], y: vote[1] }
    : { x: 0, y: 0 };

interface ConvertRatingResultsParams {
  results: RatingT['results'];
  votes: RatingT['votes'];
  choices: InteractiveContentChoice[];
}

export function convertRatingResults({
  results,
  votes,
  choices,
}: ConvertRatingResultsParams): RatingResult[] {
  return results
    .map((result) => {
      const choice = choices.find((c) => c.legacyChoiceId === result.id);
      if (!choice) {
        return null;
      }

      const choiceVotes = votes[result.id] ?? [];

      return {
        interactiveContentChoiceId: choice.interactiveContentChoiceId,
        average: averageToPoint(result.score),
        responses: choiceVotes.map(voteToPoint),
      };
    })
    .filter((result): result is RatingResult => result !== null);
}
